export default "__VITE_ASSET__CoUo6GOp__"